<template>
    <el-dialog title="服务效能统计详情" width="80%" :before-close="handleDialogClose"
               :visible.sync="dialogVisible">
            <div class="search-content">
                <el-form ref="form" class="conditionForm" :model="form" label-width="100px">
                    <el-row>
                        <el-col :span="6">
                            <el-form-item label="办结时间：">
                                <el-date-picker
                                        style="width: 100%"
                                        v-model="datetimerange"
                                        @change="searchBtn"
                                        type="daterange"
                                        format="yyyy-MM-dd"
                                        value-format="yyyy-MM-dd"
                                        range-separator="至"
                                        start-placeholder="开始日期"
                                        end-placeholder="结束日期">
                                </el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :span="4">
                            <el-form-item label="项目编号：">
                                <el-input @keyup.enter.native="searchBtn" clearable placeholder="请输入内容搜索" v-model="form.businessCode"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="4" >
                            <el-form-item label="项目名称：">
                                <el-input @keyup.enter.native="searchBtn" clearable placeholder="请输入内容搜索" v-model="form.businessName"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="5" >
                            <el-form-item label="是否超时：">
                                <el-radio-group v-model="form.timeoutFlag">
                                    <el-radio :label="true">是</el-radio>
                                    <el-radio :label="false">否</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </el-col>
                        <div class="searchBtn">
                            <el-button @click="searchBtn" size="small" type="primary">搜索</el-button>
                            <el-button @click="refresh" plain size="small">重置</el-button>
                            <el-button @click="exportTable" plain size="small">导出</el-button>
                        </div>
                    </el-row>
                </el-form>
            </div>
            <el-table :data="tableData"
                      class="table-content"
                      @sort-change="sortChange"
                      v-loading="dataListLoading"
                      :header-cell-style="this.$globalGrayTableHeaderStyle"
                      ref="multipleTable"
                      :height="tableMaxHeight" stripe border>
                <el-table-column
                        fixed
                        type="index"
                        align="center"
                        label="序号"
                        width="60"
                        :index="getRowsIndex">
                </el-table-column>
                <el-table-column align="left" header-align="center" label="项目编号" prop='businessCode' width='200'
                                 :show-overflow-tooltip='true'>
                </el-table-column>
                <el-table-column align="center" header-align="center" label="项目名称" min-width='100' prop='businessName'
                                 :show-overflow-tooltip='true'>
                </el-table-column>
                <el-table-column align="center" header-align="center" label="业务节点" min-width='100' prop='flowName'
                                 :show-overflow-tooltip='true'>
                </el-table-column>
                <el-table-column align="center" header-align="center" label="提交时间" min-width='150' prop='submitTime'
                                 :show-overflow-tooltip='true'>
                    <template slot-scope="scope">
                        <span>{{formatDate(scope.row.submitTime,'yyyy-MM-dd HH:mm')}}</span>
                    </template>
                </el-table-column>
                <el-table-column align="center" header-align="center" label="办结时间" min-width='150' prop='finishTime'
                                 :show-overflow-tooltip='true'>
                    <template slot-scope="scope">
                        <span>{{formatDate(scope.row.finishTime,'yyyy-MM-dd HH:mm')}}</span>
                    </template>
                </el-table-column>
                <el-table-column align="center" header-align="center" label="办结结果" min-width='100' prop='commitStatusName'
                                 :show-overflow-tooltip='true'>
                </el-table-column>
                <el-table-column align="center" header-align="center" label="人员姓名" min-width='100' prop='handleUserName'
                                 :show-overflow-tooltip='true'>
                </el-table-column>
                <el-table-column label="所属部门名称" prop='deptName' header-align="center" align="center" min-width='100'
                                 :show-overflow-tooltip='true'>
                </el-table-column>
                <el-table-column label="所属组织机构名称" prop='orgName' header-align="center" align="center" min-width='100'
                                 :show-overflow-tooltip='true'>
                </el-table-column>
                <el-table-column label="要求办结时限" prop='timeOutEvg' sortable header-align="center" align="center" min-width='130'
                                 :show-overflow-tooltip='true'>
                    <template slot-scope="scope">
                        <span>{{scope.row.limitTime?(scope.row.limitTime + '分钟'):'-'}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="实际办结时长" prop='timeOutEvg' sortable header-align="center" align="center" min-width='130'
                                 :show-overflow-tooltip='true'>
                    <template slot-scope="scope">
                        <span>{{scope.row.actualTime?(scope.row.actualTime + '分钟'):'-'}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="是否超时" prop='isTimeOut' header-align="center" align="center" min-width='100'
                                 :show-overflow-tooltip='true'>
                    <template slot-scope="scope">
                        <span :style="{color:scope.row.timeoutFlag?'red':'black'}">{{scope.row.timeoutFlag?'是':'否'}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="超时时长" prop='timeOutEvg' sortable header-align="center" align="center" min-width='130'
                                 :show-overflow-tooltip='true'>
                    <template slot-scope="scope">
                        <span>{{scope.row.timeoutTime?(scope.row.timeoutTime + '分钟'):'-'}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" fixed="right" align="center" width="80">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="routerDetail(scope.row,'detail')">查看</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination background
                           layout="total, sizes, prev, pager, next"
                           :page-sizes="[10, 20, 50, 100]"
                           :page-size="pageSize"
                           :total="total"
                           :current-page="pageIndex"
                           @size-change="sizeChangeHandle"
                           @current-change="currentChangeHandle"></el-pagination>
    </el-dialog>
</template>

<script>
    export default {
        name: "busWitnessTable",
        props:{
            dialogVisible: {type: Boolean, default: false},
        },
        data(){
            return {
                tableMaxHeight: document.documentElement.clientHeight - 500 ,
                dataListLoading: false,
                datetimerange:[],
                form: {
                    timeoutFlag:'',
                    businessName:'',
                    businessCode:'',
                    orgName:'',
                    deptName:'',
                    personName:'',
                },
                sortParams: {
                    order:'',
                    prop:''
                },
                groupMark:'',
                flownodesListData:[],
                moreSearchItem: false,
                checkList1: '',
                pageSize: 10,//每页条数
                pageIndex: 1,//当前页
                total: 0,//总条数
                tableData: [],
                multipleSelection: [],
                user: '', //角色类型
                formData: {}
            }
        },
        filters:{
            ellipsis(text, num) {
                if (text.length > num) {
                    return text.substring(0, num) + '...';
                } else {
                    return text;
                }
            },

        },
        created(){

        },
        activated(){
            this.getDataList()
        },
        mounted() {

            const that = this;
            let resizeTag = true;
            window.onresize = () => {
                if(resizeTag) { //防抖动
                    that.ifmove();
                    resizeTag = false
                    setTimeout(() => {
                        resizeTag = true
                    }, 1000)
                }
            }
            that.ifmove();
        },
        computed: {

        },

        methods:{

            //dialog取消
            dialogVisibleCancel(){
                this.$emit('update:dialogVisible',false)
            },
            // 点击 X 关闭对话框的回调
            handleDialogClose() {
                this.dialogVisibleCancel();
            },

            getRowsIndex(index) {
                return (this.pageIndex - 1) * this.pageSize + index + 1;
            },

            ifmove() {
                let hasBtnPermisson = this.hasBtnPermission("supervise_double_extract_btn_add") || this.hasBtnPermission("supervise_double_extract_btn_add2");
                let tableMaxHeight = document.documentElement.clientHeight - 303 +  (hasBtnPermisson ? 0 : 33);
                this.pageSize = parseInt((tableMaxHeight) / 50 ) || 1;
                this.$nextTick(() => {
                    this.tableMaxHeight = tableMaxHeight
                })

            },
            sortChange(column, prop, order){
                this.sortParams.prop = prop || column.prop;
                this.sortParams.order = order || column.order;
                this.getDataList();
            },
            getDataList(createTimeGE,createTimeLE,handleOrgId,handleUserId) { // 获取列表数据

                this.dataListLoading=true;
                this.form.statisticTimeGE = this.datetimerange[0]?this.datetimerange[0]:"";
                this.form.statisticTimeLT = this.datetimerange[1]?this.datetimerange[1]:"";
                this.$httpReq.post('/businessflowRecord/list', {
                    'page': this.pageIndex,
                    'rows': this.pageSize,
                    'orderBy':(this.sortParams.prop && this.sortParams.order)?(this.sortParams.prop + (this.sortParams.order == "ascending"?' asc':' desc')):"",
                    'filter': {
                        createTimeGE:createTimeGE,
                        createTimeLE:createTimeLE,
                        handleOrgId:handleOrgId,
                        handleUserId:handleUserId,
                        businessCode:this.form.businessCode,
                        businessName:this.form.businessName,
                        statisticTimeGE:this.form.statisticTimeGE,
                        statisticTimeLT:this.form.statisticTimeLT,
                        timeoutFlag:this.form.timeoutFlag?this.form.timeoutFlag:null
                    }
                }).then(res => {
                    this.tableData = res.data.rows;
                    this.total = res.data.total;
                    this.$refs.multipleTable.doLayout();
                    this.dataListLoading = false;
                })
            },

            sizeChangeHandle(val) {
                this.pageSize = val;
                this.pageIndex = 1
                this.getDataList()
            },
            currentChangeHandle (val) {
                this.pageIndex = val
                this.getDataList()

            },

            indexMethod(index) {
                return (this.pageIndex - 1) * this.pageSize + index + 1
            },
            handleSelectionChange(val){
                this.multipleSelection = val;
            },
            //搜索按钮
            searchBtn(){
                this.pageIndex=1;
                this.getDataList()
            },
            exportTable(){
                this.$httpReq({
                    method:'post',
                    url:'/businessflowstatistic/export',
                    responseType:'blob',
                    data: {
                      'page': 1,
                      'rows': 1000,
                      'orderBy':(this.sortParams.prop && this.sortParams.order)?(this.sortParams.prop + (this.sortParams.order == "ascending"?' asc':' desc')):"",
                      'filter': {
                        businessCode:this.form.businessCode,
                        businessName:this.form.businessName,
                        statisticTimeGE:this.form.statisticTimeGE,
                        statisticTimeLT:this.form.statisticTimeLT,
                        timeoutFlag:this.form.timeoutFlag?this.form.timeoutFlag:null
                      }
                    }
                }).then(res => {
                    const objectUrl = URL.createObjectURL(res.data);
                    let downloadLink = document.getElementById('downloadLink');
                    if (!downloadLink) {
                        downloadLink = document.createElement('a');
                        downloadLink.setAttribute('id', 'downloadLink');
                        downloadLink.setAttribute('style', 'display:none');
                        document.body.appendChild(downloadLink);
                    }
                    downloadLink.setAttribute('download', '服务效能统计.xls');
                    downloadLink.setAttribute('href', objectUrl);
                    downloadLink.click();
                    URL.revokeObjectURL(objectUrl);
                })
            },
            refresh() {//刷新按钮
                this.pageIndex = 1;
                this.form.businessName = "";
                this.form.businessCode = "";
                this.datetimerange = [];

                this.getDataList()
            },


            routerDetail(data){ // 跳转详情
                removeTabHandle("flow-efficiency-detail")
                this.$router.push({
                    name: "flow-efficiency-detail",
                    query: {
                        businessId: data.businessId || '',
                    }
                });
            },

        },

        destroyed(){
            window.onresize = null;
        },




    }
</script>
<style lang="scss" scoped>



</style>
